<template>
  <div>

    {{ $t('name') }}: {{ userDetail.name }}<br />
    {{ $t('ngo') }}: {{ userDetail.ngo_Name }}<br />
    {{ $t('country') }}: {{ userDetail.location_Name }}<br />
    {{ $t('date') }}: {{ dateCreate }}<br />

    <hr />

    <div v-for="(data, index) in formData" :key="index">
      <p>
        <strong>{{ $t('question') }}: {{ data.Question.title }} <br></strong>
        {{ $t('answer') }}: {{ data.Answer }}
      </p>
    </div>
  </div>
</template>

<script>
import { getFormDetail } from "@/util/Api/pageTemplate.js";
import { getUser } from "@/util/Api/pageTemplate.js";
import moment from "moment";

export default {
  created() {
    this.FormDetail();
    this.getUserDetail();
  },

  data() {
    return {
      formData: null,
      formTitle: null,
      userDetail: null,
      dateCreate: null
    };
  },

  methods: {
    async FormDetail() {
      if (this.$route.params.id) {
        await getFormDetail(this.$route.params.id)
          .then(response => {
            this.formTitle = response.data.form.title;
            this.formData = response.data.formContent;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async getUserDetail() {
      if (this.$route.params.id) {
        await getUser(this.$route.params.id)
          .then(response => {
            this.userDetail = response.data.userDetails[0];

            this.dateCreate = moment(
              String(this.userDetail.createdDate)
            ).format("MM/DD/YYYY");
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>
